export const MEMBER_RIGHTS = [
  { text: 'Member', value: 'member', sortable: false },
  {
    text: 'See Team Activity', value: 'see_team_activity', sortable: false,
  },
  { text: 'Can add own time', value: 'can_own_time_add', sortable: false },
  { text: 'Can add team time', value: 'can_any_time_add', sortable: false },
  { text: 'Can delete own time', value: 'can_own_time_delete', sortable: false },
  { text: 'Can delete team time', value: 'can_any_time_delete', sortable: false },
];
